import React, { useState } from 'react';
import { Badge, EmptyState, Tabs } from '../ui';
import { ago } from '../../observability/contract';
import { clock } from './units';

const STATE = {
  ALARM: { tone: 'danger', label: 'In alarm' },
  OK: { tone: 'ok', label: 'OK' },
  INSUFFICIENT_DATA: { tone: 'neutral', label: 'No data' },
};

const ORDER = { ALARM: 0, INSUFFICIENT_DATA: 1, OK: 2 };

export default function AlarmsPanel({ data, onOpenService }) {
  const [filter, setFilter] = useState('all');
  const alarms = [...(data?.alarms || [])].sort((a, b) => (ORDER[a.state] ?? 3) - (ORDER[b.state] ?? 3)
    || b.since - a.since);
  const counts = alarms.reduce((acc, a) => ({ ...acc, [a.state]: (acc[a.state] || 0) + 1 }), {});
  const shown = filter === 'all' ? alarms : alarms.filter(a => a.state === filter);

  return (
    <>
      <div className="row row-wrap gap-3 mb-3">
        <Tabs size="sm" label="Filter alarms by state" value={filter} onChange={setFilter}
              tabs={[
                { value: 'all', label: 'All', count: alarms.length },
                { value: 'ALARM', label: 'In alarm', count: counts.ALARM || 0 },
                { value: 'INSUFFICIENT_DATA', label: 'No data', count: counts.INSUFFICIENT_DATA || 0 },
                { value: 'OK', label: 'OK', count: counts.OK || 0 },
              ]} />
        <span className="text-sm text-muted">This environment's CloudWatch alarms, most urgent first</span>
      </div>
      <div className="card card-flush mb-4">
        {shown.length === 0 ? (
          <EmptyState icon="checkCircle" title="Nothing here">No alarm is in this state.</EmptyState>
        ) : (
          <div className="table-container">
            <table className="table table-stack alarm-table">
              <thead>
                <tr>
                  <th scope="col">Alarm</th>
                  <th scope="col">State</th>
                  <th scope="col">Metric</th>
                  <th scope="col">Threshold</th>
                  <th scope="col">Since</th>
                </tr>
              </thead>
              <tbody>
                {shown.map(a => {
                  const st = STATE[a.state] || { tone: 'neutral', label: a.state };
                  return (
                    <tr key={a.name} className={a.state === 'ALARM' ? 'row-alarm' : undefined}>
                      <td data-label="Alarm">
                        <span className="cell-primary">{a.name}</span>
                        {a.reason && <span className="cell-sub">{a.reason}</span>}
                        {a.service && onOpenService && (
                          <button type="button" className="btn btn-link text-xs mt-1" onClick={() => onOpenService(a.service)}>
                            Open {a.service}
                          </button>
                        )}
                      </td>
                      <td data-label="State"><Badge tone={st.tone} dot pulse={a.state === 'ALARM'}>{st.label}</Badge></td>
                      <td data-label="Metric">
                        <span className="mono text-sm">{a.metric}</span>
                        <span className="cell-sub">{a.namespace}</span>
                      </td>
                      <td data-label="Threshold">{a.threshold}</td>
                      <td data-label="Since" className="nowrap">
                        <span className="num">{ago(a.since)}</span>
                        <span className="cell-sub">{clock(a.since)}</span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
